import { hydrateQueryFromPersistedCache, removePersistedQueryCacheEntry, } from '#pplx/frontend/react-query/internal/persistedQueryCache.js';
import { keepCacheOnError } from '#pplx/frontend/react-query/utils.js';
import { hashKey } from '@tanstack/react-query';
export const getCachedInfiniteQueryPageForFallback = (data, pageParam, initialPageParam) => {
    if (!data)
        return undefined;
    const matchingPageIndex = data.pageParams.findIndex((cachedPageParam) => Object.is(cachedPageParam, pageParam));
    if (matchingPageIndex !== -1) {
        return data.pages[matchingPageIndex];
    }
    if (Object.is(pageParam, initialPageParam)) {
        return data.pages[0];
    }
    return undefined;
};
export function getPersistedInfiniteQueryOptions({ options, queryClient, allowPersist, }) {
    const originalQueryFn = options.queryFn;
    const isPersistable = allowPersist && typeof originalQueryFn === 'function';
    const persistedQueryFn = async (args) => {
        if (!isPersistable || typeof originalQueryFn !== 'function')
            throw new Error('Persisted queryFn must be a function');
        const queryKey = args.queryKey;
        const persistKey = hashKey(queryKey);
        try {
            const result = originalQueryFn(args);
            hydrateQueryFromPersistedCache({ queryClient, queryKey, persistKey });
            return await result;
        }
        catch (error) {
            if (keepCacheOnError(error)) {
                const data = queryClient.getQueryData(queryKey);
                const fallbackPage = getCachedInfiniteQueryPageForFallback(data, args.pageParam, options.initialPageParam);
                if (fallbackPage !== undefined)
                    return fallbackPage;
                throw error;
            }
            else {
                removePersistedQueryCacheEntry({ persistKey });
                throw error;
            }
        }
    };
    return { ...options, queryFn: isPersistable ? persistedQueryFn : originalQueryFn };
}
//# sourceMappingURL=getPersistedInfiniteQueryOptions.js.map